export default {"src":"/_next/static/media/gnosis-explorer.7937aebe.svg","height":143,"width":144,"blurWidth":0,"blurHeight":0};